import {Component, OnInit, TemplateRef} from '@angular/core';
import {type_branchement} from "../../../../model/db";
import {ActivatedRoute} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {valuesys} from "../../../../../../options";
import Swal from 'sweetalert2' ;
import {Translatable} from "../../../../../Translatable";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";

@Component({
  selector: 'app-type-branchement',
  templateUrl: './type-branchement.component.html',
  styleUrls: ['./type-branchement.component.css']
})
export class TypeBranchementComponent extends Translatable implements OnInit {

  title:string ;
  dtOptions: DataTables.Settings = {};

  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  modalRef: BsModalRef;

  public type_branchements:type_branchement [] = [];
  public type_branchement:type_branchement  = new type_branchement();
  type_branchement_error: type_branchement;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService
  ) { 
    super();
  }

  async ngOnInit() {
    this.auth.initAutority("TYB");

    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_users");
    this.initDatatable()
    //console.log(" liste des droits "+this.listeModules);


  }

  initDatatable(){
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {data:"label"}
      //{data:"state"}
    ]  ;
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
          .get<DataTablesResponse>(
              environment.type_branchement +"?"+  $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
          ).subscribe(resp => {
        this.type_branchements = resp.data;
        console.log(resp)
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }

  async addUserForm(){
    this.isValid = true ;
    if(this.isAdd ){
      console.log(this.type_branchement);
      let res =  await this.http.post<any>( environment.type_branchement,this.type_branchement,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        //this.rerender();
        this.type_branchements.push(res.data);
        this.close()
      }else if(res.code === 400){
        this.type_branchement_error = <type_branchement> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {

      console.log("FAL PROF",this.type_branchement);
      let res =  await this.http.put<any>( environment.type_branchement + '/' + this.type_branchement.id,this.type_branchement,valuesys.httpAuthOptions()).toPromise();

      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;

        this.close()
      }else if(res.code === 400){
        this.type_branchement_error = <type_branchement> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;

  }

  async openModal(template: TemplateRef<any>,currenttype_branchement:type_branchement =null,btn:any) {
    btn.disabled= true
    this.type_branchement_error = new type_branchement();
    if(currenttype_branchement == null){
      this.type_branchement = new type_branchement();
      this.isAdd = true ;
      this.titleModal = this.__('type_branchement.add') ;
    }else {
      this.isAdd = false ;
      this.titleModal = this.__('type_branchement.edit') ;
      let res = await this.http.get<any>(environment.type_branchement + '/' + currenttype_branchement.id,valuesys.httpAuthOptions()).toPromise();
      this.type_branchement = currenttype_branchement ;

    }
    btn.disabled= false

    this.modalRef = this.modalService.show(template,{ignoreBackdropClick:true});
  }

  close(){
    this.type_branchement_error = new type_branchement();
    this.type_branchement = new type_branchement();
    this.titleModal = "" ;
    this.modalRef.hide()
  }

  delete(deletetype_branchement:type_branchement,btn:any){
    btn.disabled= true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.type_branchement+"/"+deletetype_branchement.id,valuesys.httpAuthOptions()).toPromise();
        if(sup.code == 204){
          this.type_branchements= this.type_branchements.filter(function (item,index) {
            return item.id != deletetype_branchement.id
          });
          btn.disabled= false
          Swal.fire(
              this.__('msg.deleted'),
              sup.msg,
              'success'
          )
        }else {
          btn.disabled= false
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
            this.__('msg.canceled'),
            this.__('msg.canceled_delete'),
            'error'
        )
        btn.disabled= false
      }
    })
  }





  async toggleState(type:type_branchement,state:number,btn:any){
  //  console.log(btn.hidden = true)
    $(btn).attr('disabled');
    btn.disabled = true;
    let toogle = await this.http.get<any>( environment.type_piece+`/${type.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      type.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }


}
